import React from "react";
import {
  Popover,
  Box,
  Button,
  Typography,
  useTheme,
  Stack,
  Paper
} from "@mui/material";
import ProgressBar from "./ProgressBar";

export function UndoSendPopover({ open, handleCloseUndoSend }) {
  if (!open) return null;

  return (
    <Paper
    elevation={12}
      sx={{
        position: "fixed",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1300,
        pointerEvents: "auto",
        width: 280,
        px: 2,
        py: .75,
        borderRadius: "5px",
        bgcolor: "#F9FCFF",
        border: "1.25px solid rgba(173, 216, 230, 0.9)",
        boxShadow: "0px 4px 12px rgba(173, 216, 230, 0.4)",
            transition: 'opacity 0.3s ease',
    opacity: open ? 1 : 0,
      }}
    >
    <Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    minHeight: 40, 
  }}
>
  <Stack
    spacing={.5}
    sx={{
      flexGrow: 1,
      justifyContent: "center",
      height: "100%",
      mt:'-1px'
    }}
  >
    <Typography
      variant="subtitle3"

   
      noWrap
      sx={{ fontSize: "0.87rem", lineHeight: 1.5, color:"#395465", letterSpacing: "0.02em",  }} // dark text
    >
      Sending Notification...
    </Typography>
    <ProgressBar duration={5000} />
  </Stack>

  <Button
    size="small"
    variant="outlined"

    onClick={handleCloseUndoSend}
    sx={{
      mt:'1px',
      textTransform: "none",
      fontSize: "0.85rem",
      px: 1.25,
      py: 0.35,
      borderRadius: "5px",
      whiteSpace: "nowrap",
      minWidth: 0,
      height: "100%", 
      backgroundColor: "#FFFFFF",
      color: "#395465", 
      border: "1px solid #B0C6D0 ", 
      fontWeight: 500,
      letterSpacing: "0.03em",
 "&:hover": {
      backgroundColor: "#F7EBEF", // soft blue background on hover
        border: ".5px solid #8C4350",
      color: "#8C4350",           // slightly darker text
    },
  }}
>
  Cancel
</Button>
</Box>
    </Paper>
  );
}




